import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Form, Button, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Messages from "../components/Messages";
import { updateUser, resetUpdate, deleteAccount } from "../actions/userActions";
import { updateManager } from "../actions/managersActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Container, CardHeader, CardHeaderTitle, StyledInput, ModernButton, SettingsCard, SectionTitle, Text, GridContainer, CustomSpan, StyledSelect, PasswordContainer, StyledPasswordInput, PasswordToggleIcon } from "../components/DefaultImports";
import styled from "styled-components";
import { CustomModal } from "../components/CustomModal";
function UpdateProfile() {
  const {
    t
  } = useTranslation();
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const redirect = location.search ? location.search.split("=")[1] : "/";
  const userLogin = useSelector(state => state.userLogin);
  const {
    userInfo
  } = userLogin;
  const userUpdate = useSelector(state => state.userUpdate);
  const {
    success
  } = userUpdate;
  const manager_info = useSelector(state => state.crudManager);
  const {
    managerInfo
  } = manager_info;
  const [name, setName] = useState(userInfo.name);
  const [email, setEmail] = useState(userInfo.email);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [accountUpdated, setAccountUpdated] = useState(false);
  const [showPasswords, setShowPasswords] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletePassword, setDeletePassword] = useState("");
  const [showDeletePassword, setShowDeletePassword] = useState(false);
  const [isDeletingAccount, setIsDeletingAccount] = useState(false);
  const [deleteError, setDeleteError] = useState("");
  useEffect(() => {
    if (password !== confirmPassword) {
      setPasswordsMatch(false);
    } else {
      setPasswordsMatch(true);
    }
    if (success === true) {
      dispatch(resetUpdate());
      setAccountUpdated(true);
    }
  }, [password, confirmPassword, success, dispatch]);
  const handleSubmit = e => {
    e.preventDefault();
    const userData = {
      id: userInfo.id,
      name,
      email,
      password
    };
    if (managerInfo?.first_time_password_change === false) {
      dispatch(updateUser({
        id: userInfo.id,
        password
      }));
      dispatch(updateManager(false, false, true, false));
      navigate(redirect);
    } else {
      dispatch(updateUser(passwordsMatch ? userData : {
        id: userInfo.id,
        name,
        email
      }));
    }
  };
  const handleCancel = () => {
    setName(userInfo.name);
    setEmail(userInfo.email);
    toast.success(t("ui.i18nMessages.cancelled"), {
      autoClose: 1000
    });
  };
  const closeDeleteModal = () => {
    if (isDeletingAccount) return;
    setShowDeleteModal(false);
    setDeletePassword("");
    setDeleteError("");
    setShowDeletePassword(false);
  };
  const handleDeleteAccount = async () => {
    if (!deletePassword || isDeletingAccount) return;

    setIsDeletingAccount(true);
    setDeleteError("");

    try {
      await dispatch(deleteAccount(deletePassword));
      navigate("/login/null/null", { replace: true });
    } catch (error) {
      const detail = error?.response?.data?.detail;
      if (detail === "incorrect_password") {
        setDeleteError(t("ui.screens.profileScreen.palavraPasseIncorreta"));
      } else if (detail === "account_deletion_subscription_cancel_failed") {
        setDeleteError(
          t("ui.screens.profileScreen.naoFoiPossivelCancelarSubscricao"),
        );
      } else {
        setDeleteError(t("ui.screens.profileScreen.erroAoEliminarConta"));
      }
    } finally {
      setIsDeletingAccount(false);
    }
  };
  return <Container>
      <ToastContainer />
      <CardHeader>
        <CardHeaderTitle>{t("ui.screens.profileScreen.conta")}</CardHeaderTitle>
      </CardHeader>

      <Form onSubmit={handleSubmit}>
        <GridContainer>
          {/* Success Message */}
          {accountUpdated && <SettingsCard>
              <Messages variant="success">{t("ui.screens.profileScreen.informacoesAtualizadas")}</Messages>
            </SettingsCard>}

          {/* User Info */}
          {managerInfo?.first_time_password_change !== false && <SettingsCard>
              <SectionTitle>{t("ui.screens.profileScreen.dadosDaConta")}</SectionTitle>
              <Text style={{
            marginBottom: "0px"
          }}>{t("ui.screens.profileScreen.nomeDeUtilizador")}</Text>
              <StyledInput required type="text" value={name} onChange={e => setName(e.target.value)} style={{
            marginBottom: "0px"
          }} />
              <Text style={{
            marginBottom: "0px"
          }}>{t("ui.screens.profileScreen.enderecoDeEMail")}</Text>
              <StyledInput required type="email" value={email} onChange={e => setEmail(e.target.value)} />
            </SettingsCard>}

          {/* Alert for First Time Password */}
          {managerInfo?.first_time_password_change === false && <SettingsCard>
              <Alert variant="success">
                <Alert.Heading>
                  <i className="fas fa-smile-beam" style={{
                marginRight: "10px"
              }}></i>{t("ui.screens.profileScreen.ola")}</Alert.Heading>
                <p>{t("ui.screens.profileScreen.porSuaSegurancaNecessitamosQueTroque")}</p>
                <hr />
                <p className="mb-0">{t("ui.screens.profileScreen.vamosComecar")}</p>
              </Alert>
            </SettingsCard>}

          {/* Password Update */}
          <SettingsCard>
            <SectionTitle>{t("ui.screens.profileScreen.alterarPalavraPasse")}</SectionTitle>

            <PasswordContainer>
              <StyledPasswordInput type={showPasswords ? "password" : "text"} placeholder={t("ui.screens.profileScreen.novaPalavraPasse")} value={password} onChange={e => setPassword(e.target.value)} required />
              <PasswordToggleIcon onClick={() => setShowPasswords(!showPasswords)}>
                <FontAwesomeIcon icon={showPasswords ? faEyeSlash : faEye} />
              </PasswordToggleIcon>
            </PasswordContainer>

            <PasswordContainer>
              <StyledPasswordInput type={showPasswords ? "password" : "text"} placeholder={t("ui.screens.profileScreen.confirmarPalavraPasse")} value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required />
              <PasswordToggleIcon onClick={() => setShowPasswords(!showPasswords)}>
                <FontAwesomeIcon icon={showPasswords ? faEyeSlash : faEye} />
              </PasswordToggleIcon>
            </PasswordContainer>

            {!passwordsMatch && <Form.Text className="text-danger">{t("ui.screens.profileScreen.asPalavrasPasseNaoCoincidem")}</Form.Text>}
          </SettingsCard>
        </GridContainer>

        {/* Submit Buttons */}
        <div style={{
        display: "flex",
        justifyContent: "flex-end",
        gap: "10px"
      }}>
          <ModernButton type="submit" color="#EE754C">{t("ui.screens.profileScreen.guardar")}</ModernButton>
        </div>
      </Form>

      {managerInfo?.first_time_password_change !== false && <DangerZoneCard>
          <SectionTitle>{t("ui.screens.profileScreen.eliminarConta")}</SectionTitle>
          <DangerText>{t("ui.screens.profileScreen.eliminarContaDescricao")}</DangerText>
          <ModernButton type="button" color="#c94b42" onClick={() => {
        setDeleteError("");
        setShowDeleteModal(true);
      }}>
            <FontAwesomeIcon icon={faTrashCan} style={{
          marginRight: "7px"
        }} />
            {t("ui.screens.profileScreen.eliminarConta")}
          </ModernButton>
        </DangerZoneCard>}

      <CustomModal show={showDeleteModal} onHide={closeDeleteModal} title={t("ui.screens.profileScreen.confirmarEliminacaoConta")} footer={<>
            <ModernButton type="button" color="#99b0ad" onClick={closeDeleteModal} disabled={isDeletingAccount}>
              {t("ui.screens.profileScreen.cancelar")}
            </ModernButton>
            <ModernButton type="button" color="#c94b42" onClick={handleDeleteAccount} disabled={!deletePassword || isDeletingAccount}>
              {isDeletingAccount ? t("ui.screens.profileScreen.aEliminar") : t("ui.screens.profileScreen.eliminarDefinitivamente")}
            </ModernButton>
          </>}>
        <DeleteWarning>{t("ui.screens.profileScreen.eliminarContaAviso")}</DeleteWarning>
        <Text style={{
        marginBottom: "6px"
      }}>{t("ui.screens.profileScreen.introduzPalavraPasseParaContinuar")}</Text>
        <PasswordContainer>
          <StyledPasswordInput type={showDeletePassword ? "text" : "password"} value={deletePassword} onChange={event => {
          setDeletePassword(event.target.value);
          setDeleteError("");
        }} autoComplete="current-password" placeholder={t("ui.screens.profileScreen.palavraPasseAtual")} onKeyDown={event => {
          if (event.key === "Enter") {
            event.preventDefault();
            handleDeleteAccount();
          }
        }} />
          <PasswordToggleIcon onClick={() => setShowDeletePassword(!showDeletePassword)}>
            <FontAwesomeIcon icon={showDeletePassword ? faEyeSlash : faEye} />
          </PasswordToggleIcon>
        </PasswordContainer>
        {deleteError && <DeleteError>{deleteError}</DeleteError>}
      </CustomModal>
    </Container>;
}
export default UpdateProfile;

const DangerZoneCard = styled(SettingsCard)`
  margin-top: 24px;
  border: 1px solid rgba(201, 75, 66, 0.28);
`;
const DangerText = styled.p`
  margin: 0 0 14px;
  color: #6c757d;
  font-size: 14px;
`;
const DeleteWarning = styled.p`
  margin: 0 0 16px;
  color: #4b4b4b;
  line-height: 1.5;
`;
const DeleteError = styled.div`
  margin-top: 8px;
  color: #c94b42;
  font-size: 13px;
`;
